module.exports = __webpack_public_path__ + "static/media/win.8397272c.wav";


//////////////////
// WEBPACK FOOTER
// ./src/sound/win.wav
// module id = 59
// module chunks = 0